export default __webpack_public_path__ + "static/gem-findertips-i-new-b886286e6bc327b4c608e2b6602b4aa8.webp";